/**
 * It should return a booolean if the received day and month are inside the
 * range of the given start and end date.
 * Notice that the year given for any of the passed parameters will be ignored.
 *
 */

interface IsDateDayMonthInRangeParams {
  currentDate: Date
  startDate: string
  endDate: string
}

export const isDateDayMonthInRange = ({
  currentDate,
  startDate,
  endDate,
}: IsDateDayMonthInRangeParams): boolean => {
  const currentMonth = currentDate.getMonth()
  const currentDay = currentDate.getDate()
  const startMonth = new Date(startDate).getMonth()
  const startDay = new Date(startDate).getDate()
  const endMonth = new Date(endDate).getMonth()
  const endDay = new Date(endDate).getDate()

  if (startMonth <= endMonth) {
    // Range does not span till the end of the year (e.g., June to August)
    return (
      (currentMonth > startMonth ||
        (currentMonth === startMonth && currentDay >= startDay)) &&
      (currentMonth < endMonth ||
        (currentMonth === endMonth && currentDay <= endDay))
    )
  }

  // Range spans till the end of the year (e.g., September to March)
  return (
    currentMonth > startMonth ||
    (currentMonth === startMonth && currentDay >= startDay) ||
    currentMonth < endMonth ||
    (currentMonth === endMonth && currentDay <= endDay)
  )
}
